<div class="flex flex-row items-center">
    <input
        #selfText
        class="text-xs md:text-sm bg-ponder outline-none w-full pt-[6px] pb-[6px] pl-2 pr-2border border-transparent focus:border-ponder-bright text-slate-200" 
        placeholder="{{ filterOption.placeholder }}"
        type="text"
        autocomplete="off">
    <div class="inline-block ml-[-22px] hover:cursor-pointer size-4" (click)="clearTextInput()">
        <svg class="size-4 fill-none stroke-faded-70" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
    </div>
</div>